import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import BigCalendar from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import * as Actions from '../../instructor/store/actions';
import * as DashboardActions from '../store/actions';
import {
    Grid, IconButton, Icon, Typography, TextField, TableRow, TableCell, Card, Tooltip,
    CardContent, CardActions, Button, Divider, Table, TableBody, Slide, Paper, SnackbarContent, TableHead
} from '@material-ui/core';

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));
const allViews = ["day", "month"]

const styles = theme => ({
    root: {
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        flex: 1,
        '& .rbc-current-time-indicator': {
            display: 'none!important',
        },
        '& .rbc-header': {
            padding: '12px 6px',
            fontWeight: 500,
            fontSize: 14
        },
        '& .rbc-label': {
            padding: '8px 6px'
        },
        '& .rbc-today': {
            backgroundColor: 'transparent'
        },
        '& .rbc-header.rbc-today, & .rbc-month-view .rbc-day-bg.rbc-today': {
            borderBottom: '2px solid ' + theme.palette.secondary.main + '!important'
        },
        '& .rbc-month-view, & .rbc-time-view, & .rbc-agenda-view': {
            padding: 24,
            ...theme.mixins.border(0)
        },
        '& .rbc-agenda-view table': {
            ...theme.mixins.border(1),
            '& thead > tr > th': {
                ...theme.mixins.borderBottom(0)
            },
            '& tbody > tr > td': {
                padding: '12px 6px',
                '& + td': {
                    ...theme.mixins.borderLeft(1)
                }
            }
        },
        '& .rbc-time-view': {
            '& .rbc-time-header': {
                // ...theme.mixins.border(1)
                display: 'none'
            },
            '& .rbc-time-content': {
                flex: '0 1 auto',
                ...theme.mixins.border(1),
                overflow: 'auto',
                position: 'static',
            },
        },
        '& .rbc-month-view': {
            '& > .rbc-row': {
                ...theme.mixins.border(1)
            },
            '& .rbc-month-row': {
                ...theme.mixins.border(1),
                borderWidth: '0 1px 1px 1px!important',
                minHeight: 128
            },
            '& .rbc-header + .rbc-header': {
                ...theme.mixins.borderLeft(1)
            },
            '& .rbc-header': {
                ...theme.mixins.borderBottom(0)
            },
            '& .rbc-day-bg + .rbc-day-bg': {
                ...theme.mixins.borderLeft(1)
            }
        },
        '& .rbc-day-slot .rbc-time-slot': {
            ...theme.mixins.borderTop(1),
            opacity: 0.5
        },
        '& .rbc-time-header > .rbc-row > * + *': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-content > * + * > *': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-day-bg + .rbc-day-bg': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-header > .rbc-row:first-child': {
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-timeslot-group': {
            minHeight: 64,
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-date-cell': {
            padding: 8,
            fontSize: 16,
            fontWeight: 400,
            opacity: .5,
            '& > a': {
                color: 'inherit'
            }
        },
        '& .rbc-event': {
            borderRadius: 0,
            padding: '4px 8px',
            backgroundColor: theme.palette.primary.dark,
            color: theme.palette.primary.contrastText,
            boxShadow: theme.shadows[0],
            transitionProperty: 'box-shadow',
            transitionDuration: theme.transitions.duration.short,
            transitionTimingFunction: theme.transitions.easing.easeInOut,
            position: 'relative',
            '&:hover': {
                boxShadow: theme.shadows[2]
            }
        },
        '& .rbc-row-segment': {
            padding: '0 4px 4px 4px'
        },
        '& .rbc-off-range-bg': {
            backgroundColor: theme.palette.type === 'light' ? 'rgba(0,0,0,0.03)' : 'rgba(0,0,0,0.16)'
        },
        '& .rbc-show-more': {
            color: theme.palette.secondary.main,
            background: 'transparent'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event': {
            position: 'static'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:first-child': {
            left: 0,
            top: 0,
            bottom: 0,
            height: 'auto'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:last-child': {
            right: 0,
            top: 0,
            bottom: 0,
            height: 'auto'
        },

    },
    addButton: {
        display: 'none'
    }
});

class InstructorDashboardNew extends Component {
    constructor(props) {
        super(props);
        const instructor_id = this.props.auth.user.data.role_info.link_id;
        this.props.getDayEvents(instructor_id, moment(new Date()).format('YYYY-MM-DD'));
        this.props.getInstructorSchedule(instructor_id, moment(new Date()).format('YYYY-MM-DD'));
        this.props.getDayUnscheduledEvents(instructor_id, moment(new Date()).format('YYYY-MM-DD'));
        this.props.getEventsToGrade(instructor_id);
        this.props.getFailedEvents(this.props.auth.user.data.auth_id)
        this.state = {
            ...this.state,
            instructor_id: instructor_id,
        }
    }

    state = {
        currentView: 'day',
        date: new Date(),
    }

    onNavigate = (event) => {
        const beginningMonth = this.state.date.getMonth()
        this.setState({ date: event })
        if (event.getMonth() === beginningMonth) {
            this.props.getDayEvents(this.state.instructor_id, moment(new Date(event)).format('YYYY-MM-DD'))
            this.props.getDayUnscheduledEvents(this.state.instructor_id, moment(new Date(event)).format('YYYY-MM-DD'))
        }
        else {
            this.props.getInstructorSchedule(this.state.instructor_id, event)
            this.props.getDayEvents(this.state.instructor_id, moment(new Date(event)).format('YYYY-MM-DD'))
            this.props.getDayUnscheduledEvents(this.state.instructor_id, moment(new Date(event)).format('YYYY-MM-DD'))
        }
    }

    selectSlot = (slotInfo) => {
        this.props.getDayEvents(this.state.instructor_id, moment(new Date(slotInfo.start)).format('YYYY-MM-DD'))
        this.props.getDayUnscheduledEvents(this.state.instructor_id, moment(new Date(slotInfo.start)).format('YYYY-MM-DD'))
        this.setState({ date: slotInfo.start, currentView: 'day' })
    }

    onView = (view) => {
        this.state.currentView === 'month' ? this.setState({ currentView: 'day' }) : this.setState({ currentView: 'month' })
        this.props.getDayEvents(this.state.instructor_id, moment(new Date(this.state.date)).format('YYYY-MM-DD'))
    }

    handleEventSelect = (event) => {
        if (event.allDay) {
            return true
        }
        else {
            return this.props.history.push(`/grade/student/list/${event.id}`)
        }

    }

    eventStyleGetter = (event, start, end, isSelected) => {
        switch (event.EventType) {
            case ('fullCourse'): {
                let style = { backgroundColor: event.selected ? 'green' : event.color }
                return { style: style }
            }
            case ('fullModule'): {
                let style = { backgroundColor: event.selected ? '#B10DC9' : '#0074D9' }
                return { style: style }
            }
            case ('fullLesson'): {
                let style = { backgroundColor: event.selected ? '#01FF70' : '#FF851B' }
                return { style: style }
            }
            case ('quiz'): {
                let style = { backgroundColor: event.selected ? '#0074D9' : '#0074D9' }
                return { style: style }
            }
            case ('assignment'): {
                let style = { backgroundColor: event.color, color: this.props.theme.palette.getContrastText(event.color) }
                return { style: style }
            }
            default: {
                let style = { backgroundColor: event.selected ? 'green' : '' }
                return { style: style }
            }
        }
    }

    render() {
        const { events, dayEvents, classes, dayUnscheduledEvents, eventsToGrade, failedEventsList } = this.props;

        const gradeableEvents = eventsToGrade.map(event => {
            return (
                <TableRow key={event.gradebook_detail_id}>
                    <TableCell>{event.CourseName}</TableCell>
                    <TableCell>{event.StudentName}</TableCell>
                    <TableCell>{event.EventName}</TableCell>
                    <TableCell>{event.EventType}</TableCell>
                    <TableCell>
                        <IconButton
                            onClick={
                                event.EventType === 'Quiz' ?
                                    () => this.props.history.push(`/quiz/grader/${event.student_quiz_id}`)
                                    :
                                    () => this.props.history.push(`/assignment/grader/${event.student_assignment_id}`)
                            }
                        >
                            <Icon>edit</Icon>
                        </IconButton>
                    </TableCell>
                </TableRow>
            )
        })

        const gradeTable = (prop) => {
            if (!prop) {
                return (
                    <Card>
                        <div
                            className="flex px-24 h-64"
                            style={{
                                background: '#202020',
                                color: this.props.theme.palette.getContrastText('#202020'),
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                        >
                            <Typography
                                variant='h5'
                                style={{
                                    color: this.props.theme.palette.getContrastText('#202020'),
                                }}
                            >
                                No Events to Grade
                            </Typography>
                        </div>
                    </Card>
                )
            }
            return (

                <Card elevation={1}>
                    <div
                        className="flex px-24 h-64"
                        style={{
                            background: '#202020',
                            color: this.props.theme.palette.getContrastText('#202020'),
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        <Typography
                            variant='h5'
                            style={{
                                color: this.props.theme.palette.getContrastText('#202020'),
                            }}
                        >
                            Events to Grade
                        </Typography>
                    </div>
                    <div style={{ maxHeight: '400px', overflowY: 'scroll' }}>

                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Course Name</TableCell>
                                    <TableCell>Student Name</TableCell>
                                    <TableCell>Event Name</TableCell>
                                    <TableCell>Event Type</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {gradeableEvents}
                            </TableBody>
                        </Table>
                    </div>
                </Card >

            )
        }

        const dayUnsched = dayUnscheduledEvents.map(event => {
            return (
                <TableRow>
                    <TableCell>{event.CourseName}</TableCell>
                    <TableCell>{event.EventName}</TableCell>
                    <TableCell>{event.EventType}</TableCell>
                    <TableCell>
                        <IconButton
                            onClick={() => this.props.history.push(`/grade/student/list/` + event.company_calendar_event_id)}
                        >
                            <Icon>edit</Icon>
                        </IconButton>
                    </TableCell>
                </TableRow>
            )
        })

        const dailyToDoTable = (prop) => {
            if (!prop) {
                return (
                    <Card elevation={1}>
                        <div
                            className="flex px-24 h-64"
                            style={{
                                background: '#202020',
                                color: this.props.theme.palette.getContrastText('#202020'),
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                        >
                            <Typography
                                variant='h5'
                                style={{
                                    color: this.props.theme.palette.getContrastText('#202020'),
                                }}
                            >
                                Daily ToDo's <span style={{ fontSize: '24px', paddingLeft: '14px' }}>{moment(this.state.date).format('dddd MMM DD')}</span>
                            </Typography>
                        </div>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Course Name</TableCell>
                                    <TableCell>Event Name</TableCell>
                                    <TableCell>Event Type</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell><span style={{ fontSize: '24px' }}>No ToDos for this day</span></TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Card>
                )
            }
            return (
                <div style={{ paddingBottom: '20px' }}>
                    <Card elevation={1}>
                        <div
                            className="flex px-24 h-64"
                            style={{
                                background: '#202020',
                                color: this.props.theme.palette.getContrastText('#202020'),
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                        >
                            <Typography
                                variant='h5'
                                style={{
                                    color: this.props.theme.palette.getContrastText('#202020'),
                                }}
                            >
                                Daily ToDo's <span style={{ fontSize: '24px', paddingLeft: '14px' }}>{moment(this.state.date).format('dddd MMM DD')}</span>
                            </Typography>
                        </div>
                        <Table>
                            <TableHead>
                                <TableCell>Course Name</TableCell>
                                <TableCell>Event Name</TableCell>
                                <TableCell>Event Type</TableCell>
                                <TableCell></TableCell>
                            </TableHead>
                            <TableBody>
                                {dayUnsched}
                            </TableBody>
                        </Table>
                    </Card>
                </div>

            )
        }

        const failedEvents = failedEventsList.map(event => {
            const eventInfo =
                <div>
                    <p>Event Name: {event.EventName}</p>
                    <p>Event Type: {event.EventType}</p>
                    <p>Submission Date: {moment(event.EventSubmissionDate).format('YYYY-MM-DD')}</p>
                    <p>Score / Min: {event.EventScore + ' / ' + event.EventMinScore}</p>
                </div>
            return (
                <TableRow key={event.company_calendar_event_id + '_' + event.auth_id}>
                    <TableCell>{event.AuthName}</TableCell>
                    <TableCell>{event.CourseName}</TableCell>
                    <TableCell>
                        <Tooltip
                            title={eventInfo}
                            enterDelay={100}
                        >
                            <div className="flex items-center">
                                <Icon>info</Icon>
                            </div>
                        </Tooltip>
                    </TableCell>
                    <TableCell>
                        <Tooltip
                            title={eventInfo}
                            enterDelay={100}
                        >
                            <div className="flex items-center">
                                <Button
                                    onClick={() => this.props.handleRetakeApprove(event)}
                                    variant={'contained'}
                                >
                                    Approve Retake
                                </Button>
                            </div>
                        </Tooltip>

                    </TableCell>
                </TableRow>
            )
        })

        const failedEventsWidget = (prop) => {
            if (!prop) {
                return null
            }
            return (
                <Card elevation={1}>
                    <div
                        className="flex px-24 h-64"
                        style={{
                            background: '#202020',
                            color: this.props.theme.palette.getContrastText('#202020'),
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        <Typography
                            variant='h5'
                            style={{
                                color: this.props.theme.palette.getContrastText('#202020'),
                            }}
                        >
                            Failed Events
                        </Typography>
                    </div>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Student Name</TableCell>
                                <TableCell>Course</TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {failedEvents}
                        </TableBody>
                    </Table>
                </Card>
            )
        }

        const fullDayComponent = ({ event }) => (
            <div>
                <div style={{ fontSize: '12px' }} >{event.title} </div>
                <div style={{ fontSize: '10px' }} >{event.courseName} </div>
            </div>
        )

        const dayEventComponent = ({ event }) => (
            <div>
                {event.title}
            </div>
        )

        const calendarView = () => {
            return (
                <div>
                    <Paper>
                        <BigCalendar
                            popup
                            selectable
                            view={this.state.currentView}
                            className="flex flex-1"
                            events={this.state.currentView === 'month' ? events : dayEvents}
                            views={allViews}
                            showMultiDayTimes
                            defaultDate={new Date()}
                            onSelectSlot={(slotInfo) => this.selectSlot(slotInfo)}
                            date={this.state.date}
                            onNavigate={(event) => this.onNavigate(event)}
                            eventPropGetter={(this.eventStyleGetter)}
                            components={{ event: fullDayComponent, day: { event: dayEventComponent } }}
                            onView={(view) => this.onView(view)}
                            min={new Date(moment().startOf('day').add(8, 'hours'))}
                            max={new Date(moment().startOf('day').add(18, 'hours'))}
                            step={30}
                            onSelectEvent={event => {
                                this.handleEventSelect(event)
                            }}
                        />
                    </Paper>
                </div>
            )
        }

        return (
            <div className='p-16' >
                <div className={classes.root}>
                    <Grid container spacing={16}>
                        <Grid item xs={12}>
                            {gradeTable(eventsToGrade.length > 0)}
                        </Grid>
                        <Grid item xs={12}>
                            {failedEventsWidget(failedEventsList.length > 0)}
                        </Grid>
                        <Grid item xs={6} style={{ paddingTop: '20px' }}>
                            {calendarView()}
                        </Grid>
                        <Grid item xs={6} style={{ paddingTop: '20px' }}>
                            {dailyToDoTable(dayUnscheduledEvents.length > 0)}
                        </Grid>
                    </Grid>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getInstructorSchedule: Actions.getInstructorSchedule,
        getDayEvents: Actions.getDayEvents,
        getDayUnscheduledEvents: Actions.getDayUnscheduledEvents,
        getEventsToGrade: Actions.getEventsToGrade,
        getFailedEvents: DashboardActions.getFailedEvents,
        handleRetakeApprove: DashboardActions.retakeApprove
    }, dispatch);
}

function mapStateToProps({ auth, instructorApp, dashboardApp }) {
    return {
        auth,
        events: instructorApp.instructors.events,
        dayEvents: instructorApp.instructors.dayEvents,
        dayUnscheduledEvents: instructorApp.instructors.dayUnscheduledEvents,
        eventsToGrade: instructorApp.instructors.eventsToGrade,
        failedEventsList: dashboardApp.widgets.failedEventsList
    }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(InstructorDashboardNew)));


// WEBPACK FOOTER //
// src/main/content/dashboard/components/InstructorDashboardNew.js